// extracted by mini-css-extract-plugin
export default {"commentWithLabel":"comment-module__commentWithLabel--I4qy5","comment":"comment-module__comment--bRtyq","errorMessage":"comment-module__errorMessage--War3x"};